import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=26236417&"
import script from "./AvatarUpload.vue?vue&type=script&lang=js&"
export * from "./AvatarUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports